import { createAction, props } from '@ngrx/store'
import { TokeetCreditChargeResponse } from './model'

export const LoadTokeetCreditCharges = createAction('[Credit] Load Credit Charges', props<{ product: string }>())
export const LoadTokeetCreditChargesComplete = createAction(
  '[Credit] Load Credit Charges Complete',
  props<{ items: TokeetCreditChargeResponse[] }>()
)
